import { createClient, SupabaseClient as SupabaseClientType } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);
export const isLocalAuthBypassEnabled = process.env.REACT_APP_LOCAL_AUTH_BYPASS === 'true';

const buildSupabaseClient = (): SupabaseClientType | null => {
  if (!isSupabaseConfigured) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Supabase auth is not configured; using local auth bypass where enabled.');
    }
    return null;
  }

  try {
    return createClient(supabaseUrl, supabaseAnonKey);
  } catch (error) {
    console.error('Failed to initialize Supabase client:', error);
    return null;
  }
};

export const supabase = buildSupabaseClient();
